import React, { useEffect, useState } from "react";
import "../../scss/dashboard/dashSettings.css";
import BasicData from "./settings/BasicData";
import ImageUploade from "./settings/ImageUploade";
import DashSettingForm from "./dashSettingsForm";
import { useProfile } from "../../api/hooks/profile";
import Avatar from "../Avatar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCamera } from "@fortawesome/free-solid-svg-icons";
import Payment from "./settings/payment/payment";
function DashSettings() {
  const { profile, can } = useProfile();
  const [isFormFilled, setIsFormFilled] = React.useState(true);
  const [imageUploadModal, setImageUploadModal] = useState(false);
  const [uploadImgURL, setUploadImgURL] = useState("");
  const [shoulUpdatePic, setShoulUpdatePic] = useState(false);
  const [profileImageIs, setProfileImageIs] = useState(true);
  const [activeItem, setActiveItem] = useState("first");

  const handleEditData = () => {
    setIsFormFilled(false);
  };

  const toggle = () => {
    setIsFormFilled(true);
  };

  const handleEditarPaymentForm = () => {
    setActiveItem("first");
    setIsFormFilled(false);
  };
  const handleUploadImage = (url) => {
    setUploadImgURL(url);
    setShoulUpdatePic(true);
  };
  useEffect(() => {
    console.log(uploadImgURL);
  }, [uploadImgURL]);
  useEffect(() => {
    if (profile?.office?.logo && profile?.office?.logo !== "") {
      setProfileImageIs(true);
      setUploadImgURL(profile?.office?.logo);
    } else if (profile?.office?.logo === "") {
      setProfileImageIs(false);
    } else {
      setProfileImageIs(false);
    }
  }, [profile]);
  useEffect(() => {
    const imageListener = document.getElementById("settingImageUploadListener");
    imageListener.hidden = true;
  }, []);

  return (
    <section className="DashSettings">
      <div className="SettingsHeader">
        {profileImageIs === true ? (
          <div
            className="UploadedImage__dashboardSettings"
            style={{
              backgroundImage: `url(${profile?.office?.logo})`,
            }}
          >
            <div
              onClick={() => setImageUploadModal(true)}
              className={"addImageButton__settings"}
            >
              <FontAwesomeIcon icon={faCamera} size={"2x"} color={"#ffffff"} />
            </div>
          </div>
        ) : (
          !profileImageIs && (
            <div className="settingsDefaultAvatar">
              <div
                onClick={() => setImageUploadModal(true)}
                className={"addImageButton__settings"}
              >
                <FontAwesomeIcon
                  icon={faCamera}
                  size={"2x"}
                  color={"#ffffff"}
                />
              </div>
              <Avatar
                className="bg-accent-100 ml-3 header__avatar"
                name={profile.givenName}
                lastName={profile.familyName}
                // onClick={toggleProfileMenu}
              />
            </div>
          )
        )}
        <div className="SettingsHeaderName">
          <p>
            {profile.givenName} {profile.familyName}
          </p>
        </div>
        <div className="SettingsHeader__menu">
          <div
            className={activeItem === "first" ? "active" : ""}
            onClick={() => setActiveItem("first")}
          >
            <span>Información Personal</span>
          </div>
          <div
            className={activeItem === "second" ? "active" : ""}
            onClick={() => setActiveItem("second")}
          >
            <span>Pagos</span>
          </div>
          <div
            className={activeItem === "third" ? "active" : ""}
            onClick={() => setActiveItem("third")}
          >
            <span>Detalles de Empresa</span>
          </div>
        </div>
      </div>
      <ImageUploade
        isOpen={imageUploadModal}
        closeModal={() => setImageUploadModal(false)}
        handleSubmitPic={handleUploadImage}
      />
      {activeItem === "first" || activeItem === "third" ? (
        <>
          {!isFormFilled ? (
            <DashSettingForm
              toggle={toggle}
              requiredForm={activeItem === "first" ? "personal" : ""}
              imageURl={uploadImgURL}
            />
          ) : (
            <BasicData
              onEditData={handleEditData}
              requiredData={activeItem === "first" ? "personal" : ""}
            />
          )}
        </>
      ) : (
        activeItem === "second" && (
          <Payment
            balance={profile.balance}
            puntos={profile?.points}
            cuenta={profile?.bankData?.standarizedBankCode}
            handleEditar={handleEditarPaymentForm}
          />
        )
      )}
      <div id="settingImageUploadListener">
        <DashSettingForm
          toggle={toggle}
          requiredForm={activeItem === "first" ? "personal" : ""}
          imageURl={uploadImgURL}
          uploadImageSrc={shoulUpdatePic}
        />
      </div>
    </section>
  );
}

export default DashSettings;
